import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import { Selection } from '../../models'
import type { Feature } from '../feature'

/** Requests Zones only when the Shared workspace targets one Tenant's Zones. */
export const requestZones = store.effects.create((feature: Feature) => {
  const zoneRequest = feature.state.project(state => state.zones)

  return feature.selectors.selection.asObservable.pipe(
    rxjs.map(selection =>
      selection.mode === Selection.Mode.Shared &&
      selection.shared.targetType ===
        ents.core.agent.KnowledgeBase.Target.Type.Zone
        ? selection.shared.tenantId
        : undefined,
    ),
    rxjs.distinctUntilChanged(),
    rxjs.filter(TypeChecker.isNotNullish.raw),
    rxjs.withLatestFrom(zoneRequest.asObservable),
    rxjs.filter(
      ([tenantId, request]) =>
        request === undefined ||
        request.tenantId !== tenantId ||
        (!request.entry.loading && !request.entry.data),
    ),
    rxjs.map(([tenantId]) =>
      feature.actions.loadZones.request
        .from('Admin.KnowledgeBases.Shared.ZoneTenant.Selected')
        .create({ tenantId }),
    ),
  )
})
